<template>
  <div id="ApplyInvoice">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <el-form :model="invoice" :rules="rules" ref="invoice" label-width="110px">
      <div class="panel-box">
        <eb-panel>
          <eb-panel-header slot="header">
            <span slot="title">发票类别</span>
          </eb-panel-header>
          <div slot="body">
            <el-form-item prop="invoiceType">
              <el-radio-group v-model="invoice.invoiceType">
                <el-radio class="eb-radio radio" :disabled="isDisabled" label="0">电子普通发票</el-radio>
                <el-radio class="eb-radio radio" label="1">增值税专用发票</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </eb-panel>
      </div>
      <div class="eb-line"></div>
      <div class="panel-box">
        <eb-panel>
          <eb-panel-header slot="header">
            <span slot="title">发票信息</span>
          </eb-panel-header>
          <div slot="body">
            <el-form-item label="单位名称" prop="companyName">
              <el-input class="eb-input inputWidth" v-model="invoice.companyName" placeholder="单位名称"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别码" prop="creditCode">
              <el-input class="eb-input inputWidth" v-model="invoice.creditCode" placeholder="纳税人识别号"></el-input>
            </el-form-item>
            <el-form-item label="注册地址" prop="registerAddress">
              <el-input class="eb-input inputWidth" v-model="invoice.registerAddress" placeholder="注册地址"></el-input>
            </el-form-item>
            <el-form-item label="注册电话" prop="registerPhone">
              <el-input class="eb-input inputWidth" v-model="invoice.registerPhone" placeholder="注册电话"></el-input>
            </el-form-item>
            <el-form-item label="开户银行" prop="openBank">
              <el-input class="eb-input inputWidth" v-model="invoice.openBank" placeholder="开户银行"></el-input>
            </el-form-item>
            <el-form-item label="银行账户" prop="bankAccount">
              <el-input class="eb-input inputWidth" v-model="invoice.bankAccount" placeholder="银行账户"></el-input>
            </el-form-item>
          </div>
        </eb-panel>
      </div>
      <div class="eb-line"></div>
      <div class="panel-box">
        <eb-panel>
          <eb-panel-header slot="header">
            <span slot="title">关联订单</span>
          </eb-panel-header>
          <div slot="body">
            <ebHandsontableView :hotSettings="hotSettings" class="panel-handsontable" />
            <div class="quoteMin">总计：{{invoice.invoiceMoney}} 元</div>
          </div>
        </eb-panel>
      </div>
      <div class="eb-line"></div>
      <div class="panel-box">
        <eb-panel>
          <eb-panel-header slot="header">
            <span slot="title">发票邮寄地址</span>
          </eb-panel-header>
          <div slot="body">
            <el-form-item label="收件人" prop="receiveUser">
              <el-input class="eb-input inputWidth" v-model="invoice.receiveUser" placeholder="收件人"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="receivePhone">
              <el-input class="eb-input inputWidth" v-model="invoice.receivePhone" placeholder="联系电话"></el-input>
            </el-form-item>
            <el-form-item label="收件地址" prop="receiveAddress">
              <el-input class="eb-input inputWidth" v-model="invoice.receiveAddress" placeholder="收件地址"></el-input>
            </el-form-item>
          </div>
        </eb-panel>
      </div>
      <div class="eb-line"></div>
      <div class="panel-box">
        <div class="eb-button-group width">
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="resetForm()">取消</el-button>
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="confirmBtn('invoice')">提交申请</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import ebHandsontableView from '@/components/common/eb-handsontable-view';
import { getDepartmentById } from '@/services/org/depart-service';
import { saveInvoice } from '@/services/invoice-service';
import { getUserById } from '@/services/user/user-service';
export default {
  name: 'ApplyInvoice',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebPanel,
    ebPanelHeader,
    ebHandsontableView
  },
  data() {
    let checkRegisterPhone = (rule, value, callback) => {
      let reg = /^[0-9-]*$/;
      if (!value) {
        callback(new Error('请输入注册电话'));
      } else {
        if (!reg.test(value)) {
          callback(new Error('请输入有效的工作电话！'));
        } else {
          callback();
        }
      }
    };
    let checkReceivePhone = (rule, value, callback) => {
      let reg = /^[0-9-]*$/;
      if (!value) {
        callback(new Error('请输入手机号'));
      } else {
        if (!reg.test(value)) {
          callback(new Error('请输入有效的工作电话！'));
        } else {
          callback();
        }
      }
    };
    return {
      invoice: {
        invoiceType: '1',
        companyName: '',
        creditCode: '',
        registerAddress: '',
        registerPhone: '',
        openBank: '',
        bankAccount: '',
        invoiceMoney: '',
        receiveUser: '',
        receivePhone: '',
        receiveAddress: ''
      },
      isDisabled: true,
      orgId: this.$store.state.user.userInfo.orgId,
      userId: this.$store.state.user.userInfo.userid,
      orderIds: '',
      rules: {
        invoiceType: [{ required: true, message: '请选择发票类型', trigger: 'change' }],
        companyName: [
          { required: true, message: '请输入开发票单位名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在2 到 50 个字符', trigger: 'blur' }
        ],
        creditCode: [
          { required: true, message: '请输入纳税人识别码', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        registerAddress: [
          { required: true, message: '请输入注册地址', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        registerPhone: [{ required: true, validator: checkRegisterPhone, trigger: 'blur' }],
        openBank: [
          { required: true, message: '请输入开户银行', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: '请输入银行账户', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        receiveUser: [
          { required: true, message: '请输入发票接收人', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        receivePhone: [{ required: true, validator: checkReceivePhone, trigger: 'blur' }],
        receiveAddress: [
          { required: true, message: '请输入发票接地址', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        ]
      },
      hotSettings: {
        rowHeaders: true,
        startRows: 1,
        colHeaders: ['订单编号', '订单类型', '付款金额'],
        renderAllRows: true,
        fillHandle: false,
        data: null,
        columns: [
          {
            data: 'sysOrderNumber',
            type: 'text',
            width: 200,
            className: 'htCenter',
            readOnly: true
          },
          {
            data: 'orderType',
            type: 'text',
            readOnly: true,
            width: 150,
            renderer: (instance, td, row, col, prop, value, cellProperties) => {
              let text = this.$options.filters['orderType'](value);
              let styleText = '<div style="text-align: center;">' + text + '</div>';
              td.innerHTML = styleText;
            }
          },
          {
            data: 'transationAmount',
            width: 120,
            type: 'numeric',
            readOnly: true,
            className: 'htCenter',
            numericFormat: {
              pattern: '0,0.00'
            },
            validator: 'numeric'
          }
        ],
        cell: [{ row: 1, col: 2, comment: { value: 'this is test' } }]
      }
    };
  },
  created() {
    this.initOrderList();
    this.initDepartInfo();
  },
  methods: {
    initOrderList() {
      this.hotSettings.data = JSON.parse(sessionStorage.getItem('orderList'));
      this.invoice.invoiceMoney = sessionStorage.getItem('total');
      this.orderIds = JSON.parse(sessionStorage.getItem('orderIds'));
    },
    async initDepartInfo() {
      try {
        let [{ data: data1 }, { data: data2 }] = await Promise.all([
          getUserById(this.userId),
          getDepartmentById(parseInt(this.orgId))
        ]);
        if (data1.returnCode === '01') {
          let user = data1.user;
          this.invoice.receiveUser = user.trueName;
          this.invoice.receivePhone = user.userPhone;
          this.invoice.receiveAddress = user.address;
          this.invoice.applyUserId = user.userId;
          this.invoice.applyUserName = user.trueName;
        } else {
          this.$message.error('获取账户信息失败');
        }
        if (data2.returnCode === '01') {
          let depart = data2.depart;
          this.invoice.companyName = depart.departName;
          this.invoice.creditCode = depart.creditCode;
          this.invoice.registerAddress = depart.registerAddress;
          this.invoice.registerPhone = depart.registerPhone;
          this.invoice.openBank = depart.openBank;
          this.invoice.bankAccount = depart.bankAccount;
          this.invoice.applyOrgName = depart.departName;
          this.invoice.applyOrgId = this.orgId;
        } else {
          this.$message.error('获取机构信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    resetForm() {
      this.$router.push('/payment/list');
    },
    confirmBtn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveInvoiceInfo();
        } else {
          this.$message.error('请检查表单信息是否通过验证！');
          return false;
        }
      });
    },
    async saveInvoiceInfo() {
      let params = {
        orderIds: this.orderIds.join(','),
        invoice: JSON.stringify(this.invoice)
      };
      try {
        let { data } = await saveInvoice(params);
        if (data.returnCode === '01') {
          this.$message.success('发票申请成功');
          this.$router.push('/payment/list');
        } else {
          this.$message.error('发票申请失败');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    }
  },
  destroyed: function() {
    sessionStorage.removeItem('orderList');
    sessionStorage.removeItem('orderIds');
    sessionStorage.removeItem('total');
  }
};
</script>
<style lang="less" scoped>
#ApplyInvoice {
  .panel-box {
    width: 90%;
    margin: 0 auto;
    padding-top: 30px;
    padding-bottom: 30px;
    .inputWidth {
      width: 530px;
    }
    .radio {
      margin-right: 40px;
    }
    .width {
      margin-left: -250px;
    }
    .quoteMin {
      margin-left: 530px;
      padding: 10px 10px 0 0;
      color: #fb5b3b;
    }
  }
  .panel-handsontable {
    padding-top: 7px;
    margin-left: 110px;
  }
}
</style>
